export default __webpack_public_path__ + "static/PromptIconTen-ce52279785a7877738cd8b58105dbcde.png";